module.exports = __webpack_public_path__ + "assets/img/teacher (61).74e6d49f.png";